import Icon, { SvgIcon } from "@/components/Icon";
import { setTxt2ImgSize, statusStore, Txt2ImgSizes } from "@/stores/status";
import { themeStore } from "@/stores/theme";
import { Box, Center, Flex, Text } from "@chakra-ui/react";
import { langStore } from "@noli/business";
import { APIOption } from "@noli/core";
import { observer } from "mobx-react-lite";
import SchemaProperty from "@/components/Property/SchemaProperty";
import { genBlock } from "@/utils/bem";
import "./size-card.scss";

const block = genBlock("c-size-card");
const SizeCard = observer<{ size: Txt2ImgSizes; icon: SvgIcon }>(({ size, icon }) => {
  const lang = langStore.tgt;
  const { captionColor, lineButtonColor } = themeStore.styles;
  const e = `size_${size.split(":").join("_")}_icon`;
  const txt2imgSize = statusStore.txt2imgSize;

  const booleanCheckedPropsFn = (checked: boolean) => {
    if (checked) {
      return {
        border: "1px",
        borderColor: "transparent",
        color: "#3fc9a8",
      };
    }
    return {
      border: "1px",
      borderColor: "transparent",
    };
  };

  return (
    <Flex alignItems="center">
      <SchemaProperty
        identifier="size-card"
        lang={lang}
        noTitle
        apiKey=""
        apiOption={new APIOption("bool", txt2imgSize === size)}
        value={txt2imgSize === size}
        setValue={() => () => setTxt2ImgSize(size)}
        booleanIcon={<Icon svg={icon} className={block({ e })} fillbyCurrentColor />}
        booleanCheckedPropsFn={booleanCheckedPropsFn}
        w="46px"
        h="46px"
        color={lineButtonColor}
        _hover={{
          bgColor: "transparent",
          color: "#3fc9a8",
        }}
      />
      <Center>
        <Text fontSize="12px" color={captionColor} fontWeight={300}>
          {size}
        </Text>
      </Center>
    </Flex>
  );
});

export { SizeCard };
